import { RadialScale } from "./RadialScale";
import { Scale } from "./Scale";
import { TextScale } from "./TextScale";

const scaleTypes = {
	radial: RadialScale,
	text: TextScale,
	numeric: Scale,
};

export default scaleTypes;
